import React from 'react';
import styles from './HexMark.module.css';

interface HexMarkProps {
  size?: number;
  /** 右頂点のノード（丸）を描くか */
  node?: boolean;
  color?: 'slate' | 'navy' | 'paper';
  className?: string;
}

/** ロゴ六角形の頂点（viewBox 0 0 200 200）。Hero の線画も同じ形を使う */
export const HEX_POINTS = '60,30.7 140,30.7 180,100 140,169.3 60,169.3 20,100';

const COLOR_VAR: Record<NonNullable<HexMarkProps['color']>, string> = {
  slate: 'var(--color-slate)',
  navy: 'var(--color-navy)',
  paper: 'var(--color-paper)',
};

/** ロゴ由来の六角形。装飾専用なので常に aria-hidden */
const HexMark: React.FC<HexMarkProps> = ({
  size = 14,
  node = true,
  color = 'slate',
  className,
}) => {
  const stroke = COLOR_VAR[color];
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className={`${styles.mark} ${className ?? ''}`.trim()}
    >
      <polygon
        points={HEX_POINTS}
        fill="none"
        stroke={stroke}
        strokeWidth={node ? 14 : 18}
        strokeLinejoin="round"
      />
      {node && <circle cx="180" cy="100" r="24" fill={stroke} />}
    </svg>
  );
};

export default HexMark;
